/**
 * Appointments API
 * Appointment scheduling and management
 */

import { crmGet, crmPost, crmPut, crmDelete } from './crmConfig';

/**
 * Fetch all appointments
 * @param {Object} params - Optional query parameters
 */
export const fetchAppointments = async (params) => {
  const response = await crmGet('/api/appointments', params);
  return response.data;
};

/**
 * Fetch upcoming appointments
 * @param {Object} params - Optional query parameters
 */
export const fetchUpcomingAppointments = async (params) => {
  const response = await crmGet('/api/appointments/upcoming', params);
  return response.data;
};

/**
 * Create a new appointment
 * @param {Object} data - Appointment data
 */
export const createAppointment = async (data) => {
  const response = await crmPost('/api/appointments', data);
  return response.data;
};

/**
 * Update an appointment
 * @param {string} id - Appointment ID
 * @param {Object} data - Appointment data to update
 */
export const updateAppointment = async (id, data) => {
  const response = await crmPut(`/api/appointments/${id}`, data);
  return response.data;
};

/**
 * Delete an appointment
 * @param {string} id - Appointment ID
 */
export const deleteAppointment = async (id) => {
  const response = await crmDelete(`/api/appointments/${id}`);
  return response.data;
};
